import { render, staticRenderFns } from "./LastRequest.vue?vue&type=template&id=0301c73c&scoped=true&"
import script from "./LastRequest.vue?vue&type=script&lang=ts&"
export * from "./LastRequest.vue?vue&type=script&lang=ts&"
import style0 from "./LastRequest.vue?vue&type=style&index=0&id=0301c73c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0301c73c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
